// src/apps/charm/next.config.mjs mirrors this list for its security headers.
export const PRIVATE_APPLICATION_PATHS = [
  "/mygas",
  "/annuity/apply",
  "/annuity/applications",
  "/charm/myga-applications",
];

export function isMygaPrivatePath(pathname: string): boolean {
  return PRIVATE_APPLICATION_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`),
  );
}

export function isMygaPrivateUrl(url: string): boolean {
  try {
    return isMygaPrivatePath(new URL(url, "https://goldfinch.com").pathname);
  } catch {
    return true;
  }
}

export function requiresMygaDocumentNavigation(
  initialPath: string,
  nextPath: string,
): boolean {
  return mygaDocumentScope(initialPath) !== mygaDocumentScope(nextPath);
}

function mygaDocumentScope(pathname: string) {
  if (!isMygaPrivatePath(pathname)) {
    return "public";
  }
  if (pathname === "/mygas" || pathname === "/mygas/") {
    return "lead";
  }
  return pathname.startsWith("/charm/myga-applications")
    ? "review"
    : "application";
}
